<div class="d-print-none">
    @if (sseService?.showNotification()) {
        <div 
            class="header-update-warning" 
            [class.nav-whitespace]="navSpacerVisible()"
        >
            <span>HOMER has been updated with new features.</span>&nbsp;
            <a 
                href="#" 
                (click)="hardReload()" 
                class="header-update-button"
            >Click here to reload the page.</a>
        </div>
    } 
    
    @else if (sseDisconnected() && sseService?.sseOptions() != null) {
        @if (sseNotificationHidden()) {    
            <span 
                style='pointer-events:auto;'
                pTooltip='Live updates are unavailable.&#010;Click for more info.'
                tooltipPosition='left'
                appendTo='body'
                tooltipStyleClass='text-center'
                class="p-0 my-1 mx-3 float-right" 
            >
                <p-button 
                    icon="pi pi-sort-alt-slash"
                    styleClass="p-0 bg-warning border-warning" 
                    raised
                    rounded
                    severity='warn'
                    size="small"
                    (onClick)="toggleHidden()"
                ></p-button>
            </span>
        } @else if (sseFailed()) {
            <div class="header-update-warning text-dark justify-content-center bg-warning p-1" [class.nav-whitespace]="navSpacerVisible()">
                <span class='font-weight-bold w-100 text-center pl-4'>
                    Live updates have been disabled, chat features and background processes will not update automatically.
                </span>

                <p-button 
                    icon="pi pi-eye-slash"
                    styleClass="p-0 mx-1" 
                    raised
                    severity='secondary'
                    size="small"
                    (onClick)="toggleHidden()"
                ></p-button>
            </div>
        } @else {
            <div class="header-update-warning p-1" [class.nav-whitespace]="navSpacerVisible()">
                <span class='w-100 text-center pl-4'>
                    Refresh page to enable live updates or
                    <p-button 
                        link
                        [loading]='sseIsConnecting()'
                        [disabled]='sseIsConnecting()'
                        iconPos='right'
                        styleClass="p-0 text-primary" 
                        severity='info'
                        label="Click here to reconnect."
                        (onClick)="reconnectSSE()"
                    ></p-button>
                </span>
                
                <p-button 
                    icon="pi pi-eye-slash"
                    styleClass="p-0 mx-1" 
                    raised
                    severity='secondary'
                    size="small"
                    (onClick)="toggleHidden()"
                ></p-button>
            </div>
        } 
    } 

    @if (scheduledInstall()) {
        <pcg-install-timer #installTimer></pcg-install-timer>
    }
</div>